import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ClientFormLayer from "../components/ClientFormLayer";
import { useParams } from "react-router-dom";

const ClientFormPage = () => {
  const { id } = useParams();
  const title = id ? "Edit Client Registration" : "Client Registration";
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>


        <ClientFormLayer />
      </MasterLayout>
    </>
  );
};

export default ClientFormPage;
